import { logOut } from "./User.js";
import jwt from 'jwt-decode';

//const backendurl = 'http://localhost:8000/api/';
//const backendurl = 'http://172.17.1.90:8000/api/';
const backendurl = 'https://api.fundacion360.com.ar/api/';

// VER: (Parametro opcional de timeout)
export async function POST(url, request, timeout = 0){
     
    return await fetch(backendurl + url, {
        method:'POST',
        mode:'cors',
        headers:{
            'Content-Type':'application/json',
            'Authorization': `Bearer ${localStorage.getItem('access_token')}` || ''
        },
        body: JSON.stringify(request)
    })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => {
        if(err?.Error === true){
            if(err?.Data === true){
                logOut();
            }

            if(err?.Data === false){
                console.log(err.Message);
            }
        }

        return err;

    });
}


export async function GET(url, request = null){

    let uri = "";
    if(request){
        uri = '?' + new URLSearchParams(request).toString();
    }

    return await fetch(backendurl + url + uri, {
        method:'GET',
        mode:'cors',
        headers:{
            'Authorization': `Bearer ${localStorage.getItem('access_token')}` || ''
        }
    })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => {
        if(err?.Error === true){
            if(err?.Data === true){
                logOut();
            }

            if(err?.Data === false){
                console.log(err.Message);
            }
        }

        return err;

    });
}

export async function PATCH(url, request){

    return await fetch(backendurl + url, {
        method:'PATCH',
        mode:'cors',
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}` || '',
            'Content-Type':'application/json'
        },
        body: JSON.stringify(request)
    })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => {
        if(err?.Error === true){
            if(err?.Data === true){
                logOut();
            }

            if(err?.Data === false){
                console.log(err.Message);
            }
        }

        return err;

    });
}

export async function DELETE(url, request){

    let uri = "";
    if(request){
        uri = '?' + new URLSearchParams(request).toString();
    }

    return await fetch(backendurl + url + uri, {
        method:'DELETE',
        mode:'cors',
        headers:{
            'Authorization': `Bearer ${localStorage.getItem('access_token')}` || ''
        }
    })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => {
        if(err?.Error === true){
            if(err?.Data === true){
                logOut();
            }

            if(err?.Data === false){
                console.log(err.Message);
            }
        }

        return err;

    });
}

export async function POSTU(url, file){

    let data = new FormData();
    data.append('file', file);

    return await fetch(backendurl + url, {
        method:'POST',
        mode:'cors',
        headers:{
            'Authorization': `Bearer ${localStorage.getItem('access_token')}` || ''
        },
        body: data
    })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => {
        if(err?.Error === true){
            if(err?.Data === true){
                logOut();
            }

            if(err?.Data === false){
                console.log(err.Message);
            }
            
            let token = localStorage.getItem('access_token');

            let tokenDecoded = jwt(token);

            const timestampMillis = Date.now();
            const timestampSeconds = Math.floor(timestampMillis / 1000);

            if (tokenDecoded.exp < timestampSeconds) {
                window.alert('Su sesion expiro, vuelva a ingresar en la plataforma.');
                logOut();
                window.location.reload();
              }
        }
    });
}